/** @zhxt/icon-library — 可移植图标核心（前后端 / 其他项目共用） */
/**
 * 队员水滴图标目录：图案 + 按速度自动匹配
 * 速度单位：m/s（与 devices.last_speed / 弹窗展示一致）
 */

/** 彩色水滴外形（viewBox 0 0 28 36）——指挥页默认 */
const TEARDROP_PATH =
  'M14 1C7.4 1 2 6.4 2 13c0 9.5 12 21 12 21s12-11.5 12-21C26 6.4 20.6 1 14 1z';

/** 灰色水滴：银边立体外壳，尖头收成小圆弧 */
const CHROME_TEARDROP_PATH =
  'M14 1.5C7.4 1.5 2.2 6.8 2.2 13.4C2.2 19.6 9.2 28.8 13.05 32.95Q14 34.2 14.95 32.95C18.8 28.8 25.8 19.6 25.8 13.4C25.8 6.8 20.6 1.5 14 1.5Z';

/** 灰色水滴内圆圆心与半径 */
const GEM_CX = 14;
const GEM_CY = 12.15;
const GEM_R = 8.9;

const ICON_STYLES = [
  { id: 'chrome', label: '灰色水滴', description: '默认队员坐标：银灰外壳；内圆五态表示在线/暂时离线/选中/高亮/离线' },
  { id: 'flat', label: '彩色水滴', description: '整颗水滴着色，白色图案' }
];

/** 灰色水滴 · 水滴主题状态（内圆颜色，对应参考 PNG） */
const WATER_DROP_STATES = [
  { color: 'lightblue', fill: '#2ea8ff', label: '水滴·浅蓝', description: '在线' },
  { color: 'orange', fill: '#f59e0b', label: '水滴·橙', description: '暂时离线' },
  { color: 'red', fill: '#e23b3b', label: '水滴·红', description: '选中/告警' },
  { color: 'darkblue', fill: '#2b5fd0', label: '水滴·深蓝', description: '高亮' },
  { color: 'gray', fill: '#8a93a0', label: '水滴·灰', description: '离线' }
];

/**
 * 白色图案（中心约 14,12，再经 GLYPH_SCALE）
 * - 人物：头 + 躯干 + 明确两臂两腿（禁止多肢/速度线/山峰冒充徒步）
 * - 载具：侧视剪影；窗/轮用 evenodd 挖孔（透出水滴底色，任意针色都正确）
 */
const MEMBER_ICON_GLYPHS = {
  water_drop: '<circle cx="14" cy="12" r="3.2" fill="#fff"/>',

  person:
    '<circle cx="14" cy="8" r="2.15" fill="#fff"/>' +
    '<path fill="#fff" d="M9.8 11.8c0-1.5 1.8-2.4 4.2-2.4s4.2.9 4.2 2.4V18h-8.4z"/>',

  // 徒步：背包行人 + 登山杖（不是山峰）
  hike:
    '<circle cx="13.2" cy="7.6" r="1.65" fill="#fff"/>' +
    '<path fill="#fff" d="M11.6 9.5h3.1v3.2h-1.15v4.5h-1.35v-4.5H11.6z"/>' +
    '<path fill="#fff" d="M14.7 9.8h2.15c.35 0 .65.3.65.65v2.9c0 .35-.3.65-.65.65H14.7z"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.45" stroke-linecap="round" d="M10.4 14.6l-1.9 3.1M14.2 14.6l2.1 3.1"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.4" stroke-linecap="round" d="M17.5 8.2v9.2M16.5 8.4h2"/>',

  // 步行：正面迈步，仅两腿两臂
  walk:
    '<circle cx="14" cy="7.5" r="1.7" fill="#fff"/>' +
    '<path fill="#fff" d="M11.7 9.5h4.6v3.4h-1.4v4.8h-1.8v-4.8h-1.4z"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" d="M11.4 13.2l-2.3 3.6M16.6 13.2l2.3 3.6"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.35" stroke-linecap="round" d="M11.5 11.2l-2 1.5M16.5 11.2l2 1.5"/>',

  // 跑步：前倾，仅两臂 + 两腿
  run:
    '<circle cx="16.4" cy="7.4" r="1.55" fill="#fff"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" d="M13.2 10.2l3.4-1.1 1.1 2.4-2.6 1"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.55" stroke-linecap="round" d="M17.4 10l2.6.7M13.6 11.2l-2.8 1.3"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.65" stroke-linecap="round" d="M15 12.4l3.2 3.6M14.6 12.6l-3.4 3.2"/>',

  // 攀爬：梯子 + 攀爬者
  climb:
    '<path fill="none" stroke="#fff" stroke-width="1.35" stroke-linecap="round" d="M9 8v10M12.2 8v10M9 10h3.2M9 12.4h3.2M9 14.8h3.2"/>' +
    '<circle cx="15.6" cy="8.6" r="1.4" fill="#fff"/>' +
    '<path fill="#fff" d="M14.2 10.2h2.7v2.6h-1v3.6h-1.2v-3.6h-.5z"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.4" stroke-linecap="round" d="M14 10.8l-2.2-.6M17.2 11.2l2-.9M14.4 15.2l-1.8 1.5M16.4 15.2l1.5 1.5"/>',

  bicycle:
    '<circle cx="10.2" cy="15.2" r="2.65" fill="none" stroke="#fff" stroke-width="1.2"/>' +
    '<circle cx="18" cy="15.2" r="2.65" fill="none" stroke="#fff" stroke-width="1.2"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" d="M10.2 15.2l3.1-5.3h3.1L18 15.2M13.3 9.9l1.9 5.3M15.3 8.7h2.5"/>',

  motorcycle:
    '<circle cx="10" cy="15.5" r="2.45" fill="none" stroke="#fff" stroke-width="1.2"/>' +
    '<circle cx="18.3" cy="15.5" r="2.45" fill="none" stroke="#fff" stroke-width="1.2"/>' +
    '<path fill="#fff" d="M11.2 13.8h5.2l1.8-3.4h2l.45 1.2-1.55 3.5h-7.9z"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.25" stroke-linecap="round" d="M17.2 9.2h2.8M17.2 9.2v1.8M10 15.5h1.5"/>' +
    '<circle cx="14.5" cy="9.8" r="1.15" fill="#fff"/>',

  car:
    '<path fill="#fff" fill-rule="evenodd" d="M8.3 13.6h11.4v2.6h-.7a1.65 1.65 0 0 1-3.2 0h-2.6a1.65 1.65 0 0 1-3.2 0h-.7zM9.7 13.6l1.5-3.2h5.6l1.5 3.2zM11.1 16.5a1.2 1.2 0 1 0 .01 0zm5.9 0a1.2 1.2 0 1 0 .01 0z"/>',

  truck:
    '<path fill="#fff" fill-rule="evenodd" d="M7.8 9.5h8v7.4H7.8zM15.8 12.2H20v4.7h-.75a1.5 1.5 0 0 1-2.9 0h-.55zM9.2 10.7h5v2.1h-5zM10.5 16.9a1.2 1.2 0 1 0 .01 0zm7.3 0a1.2 1.2 0 1 0 .01 0z"/>',

  bus:
    '<path fill="#fff" fill-rule="evenodd" d="M9 8h10v9.6H9zM10.4 9.5h2v1.7h-2zM13.2 9.5h2v1.7h-2zM16 9.5h1.8v1.7H16zM10.4 12.2h7.2v1H10.4zM11.4 17.5a1.15 1.15 0 1 0 .01 0zm5.4 0a1.15 1.15 0 1 0 .01 0z"/>',

  train:
    '<path fill="#fff" fill-rule="evenodd" d="M8.4 14.2c0-2.8 1.9-5.2 4.8-5.6L19.2 8.2c1 .15 1.7 1 1.7 2v5c0 .6-.5 1.1-1.1 1.1H9.5c-.6 0-1.1-.5-1.1-1.1zM11 10h2.3v2H11zm3.1 0h2.3v2h-2.3zm3.1 0H19v2h-1.8zM12.2 16.8a1.1 1.1 0 1 0 .01 0zm5.4 0a1.1 1.1 0 1 0 .01 0z"/>',

  subway:
    '<path fill="none" stroke="#fff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" d="M10.2 16.4V9.2l3.8 5.4 3.8-5.4v7.2"/>',

  // 飞机：长机身俯视（避免星形）
  airplane:
    '<path fill="#fff" d="M13.2 6.5h1.6v4.3h6v1.65h-6v2.2h3.5v1.4H14.8V18.5h-1.6v-2.45H9.7v-1.4h3.5v-2.2h-6V10.8h6z"/>',

  helicopter:
    '<path fill="#fff" d="M7.8 8.6h12.4v1.2H7.8z"/>' +
    '<path fill="#fff" d="M10.8 9.8h5.6c.75 0 1.35.55 1.35 1.25v2.2c0 .7-.6 1.25-1.35 1.25h-2.1l-.85 2H10.8V9.8z"/>' +
    '<path fill="#fff" d="M16.4 12.2h4.6v1.15l-1.7 1v1.35h-1.25v-1.55l-1.65-.95z"/>' +
    '<path fill="#fff" d="M10.2 15.6h6.8v1.1H10.2z"/>',

  boat:
    '<path fill="#fff" d="M14 7.8l4.4 5.8H14z"/>' +
    '<path fill="#fff" d="M8.2 14h11.6l-1.6 3.3H9.8z"/>',

  ambulance:
    '<path fill="#fff" fill-rule="evenodd" d="M8 11.2h12v5.2H8zM10.2 11.2V9.2h4.4v2zM11.2 16.5a1.1 1.1 0 1 0 .01 0zm5.8 0a1.1 1.1 0 1 0 .01 0z"/>' +
    '<path stroke="#dc2626" stroke-width="1.55" stroke-linecap="round" d="M12.2 12.6h3.6M14 11v3.2"/>',

  fire_truck:
    '<path fill="#fff" fill-rule="evenodd" d="M8 11.8h7.2v5H8zM15.2 11.8h4.6v5h-.7a1.45 1.45 0 0 1-2.8 0h-1.1zM10.8 9.4h3.2v2.4h-3.2zM11 16.9a1.15 1.15 0 1 0 .01 0zm7 0a1.15 1.15 0 1 0 .01 0z"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.4" stroke-linecap="round" d="M13.4 9.2l6.2-2.6"/>',

  medical:
    '<circle cx="14" cy="12" r="5" fill="#fff"/>' +
    '<path stroke="#dc2626" stroke-width="1.85" stroke-linecap="round" d="M14 9.1v5.8M11.1 12h5.8"/>',

  // 警察：盾牌 + 星形挖孔
  police:
    '<path fill="#fff" fill-rule="evenodd" d="M14 7.4l5.2 1.6v4.2c0 3.2-2.2 5.4-5.2 6.4-3-1-5.2-3.2-5.2-6.4V9zM14 10.4l.7 1.4h1.55l-1.25.95.45 1.55L14 13.7l-1.45.95.45-1.55-1.25-.95H13.3z"/>',

  // 救援：救生圈
  rescue:
    '<circle cx="14" cy="12" r="5.1" fill="none" stroke="#fff" stroke-width="2.4"/>' +
    '<circle cx="14" cy="12" r="2.2" fill="none" stroke="#fff" stroke-width="1.5"/>' +
    '<path stroke="#dc2626" stroke-width="1.6" stroke-linecap="round" d="M14 7.4v1.8M14 14.8v1.8M7.4 12h1.8M18.8 12h1.8"/>',

  fire:
    '<path fill="#fff" d="M14 17.6c-2.85 0-4.6-2-4.6-4.4 0-1.5.7-2.7 1.5-3.6.2 1.1.8 1.7 1.4 2.1-.1-1.8.5-3.5 1.7-4.7 1.3 1.1 2.1 2.5 2.4 4 .5-.4 1.1-1.2 1.3-2.2.9 1.1 1.5 2.5 1.5 4.1 0 2.5-1.8 4.7-4.2 4.7z"/>',

  camp:
    '<path fill="#fff" fill-rule="evenodd" d="M14 7.6l6.2 10H7.8zM14 11.2l2.2 6.4h-4.4z"/>',

  flag:
    '<path stroke="#fff" stroke-width="1.55" stroke-linecap="round" d="M10.8 8v10.2"/>' +
    '<path fill="#fff" d="M11.2 8.2h6l-1.55 2.25L17.2 12.7H11.2z"/>',

  star:
    '<path fill="#fff" d="M14 7.6l1.4 2.95 3.2.4-2.35 2.3.6 3.2L14 14.95l-2.85 1.5.6-3.2-2.35-2.3 3.2-.4z"/>',

  heart:
    '<path fill="#fff" d="M14 17.2l-4.7-4.5a2.8 2.8 0 0 1 4-3.95L14 9.4l.7-.65a2.8 2.8 0 0 1 4 3.95z"/>',

  diamond:
    '<path fill="#fff" d="M14 7.8l4.3 3.6-4.3 6-4.3-6z"/>',

  circle: '<circle cx="14" cy="12" r="4" fill="none" stroke="#fff" stroke-width="1.6"/>',
  square: '<rect x="10.4" y="8.6" width="7.2" height="7.2" rx="0.5" fill="none" stroke="#fff" stroke-width="1.5"/>',
  triangle: '<path d="M14 8.4l4.4 8H9.6z" fill="none" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/>',

  swim:
    '<circle cx="10.6" cy="9.2" r="1.45" fill="#fff"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.55" stroke-linecap="round" d="M12 10.2l3.2.6M15.2 10.8l2.6-1.4"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.35" stroke-linecap="round" d="M8.6 14.4c1.6-.7 3.2-.95 4.8-.95 1.7 0 3.2.7 4.8 1.15 1.1.3 2.2.15 3.1-.4"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.25" stroke-linecap="round" d="M9 16.6c1.4-.5 2.8-.7 4.2-.7 1.5 0 2.9.5 4.3.85"/>',

  ski:
    '<circle cx="15.4" cy="7.8" r="1.4" fill="#fff"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.55" stroke-linecap="round" d="M14 9.6l1.8-.4 1 3.2M14.2 12.2l-1.6 3.4M16.4 12.4l2 3"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.45" stroke-linecap="round" d="M8.6 17.2l11-.8"/>',

  snowboard:
    '<path fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" d="M8.4 15.8l11.2 2.4"/>' +
    '<circle cx="13.6" cy="8.4" r="1.35" fill="#fff"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" d="M13.6 9.9v3.4M12.2 13.6l1.4 2.2 1.5-1.6"/>',

  surf:
    '<path fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" d="M8.2 16.4c2.2-3.6 6.5-4.2 9.8-1.2"/>' +
    '<path fill="#fff" d="M18.2 12.2c1.2.4 2.2 1.6 2.4 3.2-1.4-.2-2.6-.9-3.4-2z"/>' +
    '<circle cx="12.8" cy="8.6" r="1.35" fill="#fff"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" d="M12.8 10.1v4.2M11.6 12.2h2.4M12.2 14.4l-.6 1.8M13.4 14.4l.8 1.7"/>',

  fish:
    '<path fill="none" stroke="#fff" stroke-width="1.45" stroke-linecap="round" d="M9.2 8.4l6.4 4.2"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.2" stroke-linecap="round" d="M15.6 12.6c.2 1.4.1 2.6-.4 3.6"/>' +
    '<path fill="#fff" d="M14.8 15.4c1.6-1.5 4.2-1.3 5.4.3-1.4 1.6-3.8 1.7-5.4.4z"/>' +
    '<path fill="#fff" d="M20.2 15.7l1.7-1.2v2.5z"/>' +
    '<circle cx="9" cy="8.2" r="1.1" fill="#fff"/>',

  hunt:
    '<circle cx="14" cy="12" r="4.4" fill="none" stroke="#fff" stroke-width="1.45"/>' +
    '<circle cx="14" cy="12" r="1.35" fill="none" stroke="#fff" stroke-width="1.3"/>' +
    '<path stroke="#fff" stroke-width="1.35" stroke-linecap="round" d="M14 6.8v2.2M14 15v2.2M6.8 12h2.2M15 12h2.2"/>',

  stationary:
    '<circle cx="14" cy="12" r="3.4" fill="none" stroke="#fff" stroke-width="2"/>' +
    '<circle cx="14" cy="12" r="1.25" fill="#fff"/>'
};

/** 灰色水滴不展示这些扁平目录项（参考库无对应图） */
const CHROME_SKIP_KEYS = new Set(['star', 'heart', 'diamond', 'circle']);

/** 参考库额外图标（仅灰色水滴） */
const CHROME_EXTRA_CATALOG = [
  { key: 'important_place', label: '重要地点', description: '参考库' },
  { key: 'focus', label: '关注点', description: '参考库' },
  { key: 'info', label: '信息点', description: '参考库' },
  { key: 'destination', label: '目的地', description: '参考库' },
  { key: 'square_point', label: '方形点', description: '参考库' },
  { key: 'mountain_point', label: '三角形点', description: '参考库' },
  { key: 'stationary_2', label: '静止-备用', description: '参考库' },
  { key: 'person_2', label: '人员-备用', description: '参考库' }
];

const CHROME_EXTRA_KEYS = new Set(CHROME_EXTRA_CATALOG.map((i) => i.key));

/** 目录（管理后台 / 选择器） */
const MEMBER_ICON_CATALOG = [
  { key: 'water_drop', label: '水滴', description: '默认' },
  { key: 'stationary', label: '静止', description: '停留/几乎不动' },
  { key: 'person', label: '人员', description: '普通人员' },
  { key: 'hike', label: '徒步', description: '背包/登山杖' },
  { key: 'walk', label: '步行', description: '步行' },
  { key: 'run', label: '跑步', description: '奔跑（两腿）' },
  { key: 'climb', label: '攀爬', description: '攀梯/攀岩' },
  { key: 'bicycle', label: '自行车', description: '骑行' },
  { key: 'motorcycle', label: '摩托车', description: '摩托' },
  { key: 'car', label: '汽车', description: '轿车/越野' },
  { key: 'truck', label: '卡车', description: '货车' },
  { key: 'bus', label: '公交车', description: '客车' },
  { key: 'train', label: '动车', description: '火车/高铁' },
  { key: 'subway', label: '地铁', description: '地铁车厢' },
  { key: 'airplane', label: '飞机', description: '航空（俯视）' },
  { key: 'helicopter', label: '直升机', description: '直升机' },
  { key: 'boat', label: '船只', description: '船/筏' },
  { key: 'ambulance', label: '救护车', description: '医疗转运' },
  { key: 'fire_truck', label: '消防车', description: '消防' },
  { key: 'medical', label: '医疗', description: '医疗点' },
  { key: 'police', label: '警察', description: '盾牌徽章' },
  { key: 'rescue', label: '救援', description: '救生圈' },
  { key: 'fire', label: '火', description: '火情' },
  { key: 'camp', label: '露营', description: '帐篷' },
  { key: 'swim', label: '游泳', description: '水域' },
  { key: 'ski', label: '滑雪', description: '滑雪' },
  { key: 'snowboard', label: '滑雪板', description: '单板' },
  { key: 'surf', label: '冲浪', description: '冲浪' },
  { key: 'fish', label: '钓鱼', description: '鱼竿+鱼' },
  { key: 'hunt', label: '狩猎', description: '准星' },
  { key: 'flag', label: '旗帜', description: '标记' },
  { key: 'star', label: '星星', description: '重点' },
  { key: 'heart', label: '心形', description: '关注' },
  { key: 'diamond', label: '钻石', description: '菱形' },
  { key: 'circle', label: '圆形', description: '几何' },
  { key: 'square', label: '方形', description: '几何' },
  { key: 'triangle', label: '三角形', description: '几何' }
];

/**
 * 速度 → 图标（上限 m/s，升序匹配）
 * 约：静止&lt;1.4km/h | 徒步&lt;7 | 跑&lt;16 | 骑&lt;30 | 摩&lt;58 | 车&lt;126 | 动车&lt;252 | 飞机
 */
const SPEED_ICON_BANDS = [
  { key: 'stationary', maxMs: 0.4, label: '静止', maxKmh: 1.4 },
  { key: 'hike', maxMs: 2.0, label: '徒步', maxKmh: 7.2 },
  { key: 'run', maxMs: 4.5, label: '跑步', maxKmh: 16.2 },
  { key: 'bicycle', maxMs: 8.5, label: '自行车', maxKmh: 30.6 },
  { key: 'motorcycle', maxMs: 16, label: '摩托车', maxKmh: 57.6 },
  { key: 'car', maxMs: 35, label: '汽车', maxKmh: 126 },
  { key: 'train', maxMs: 70, label: '动车', maxKmh: 252 },
  { key: 'airplane', maxMs: Infinity, label: '飞机', maxKmh: null }
];

const TEARDROP_PUBLIC_DIR = '/markers/teardrop';
const CHROME_PUBLIC_DIR = '/markers/teardrop-chrome';

/** 彩色水滴图案放大 */
const GLYPH_SCALE = 1.38;
const GLYPH_CX = 14;
const GLYPH_CY = 12;
const GLYPH_SCALE_CHROME = 1.28;

let teardropUidSeq = 0;

function wrapScaledGlyph(glyphHtml, scale = GLYPH_SCALE, cx = GLYPH_CX, cy = GLYPH_CY) {
  return `<g transform="translate(${cx} ${cy}) scale(${scale}) translate(${-cx} ${-cy})">${glyphHtml}</g>`;
}

function clampByte(n) {
  return Math.max(0, Math.min(255, Math.round(n)));
}

function hexToRgb(hex) {
  const h = String(hex).replace('#', '');
  const n = h.length === 3 ? h.split('').map((c) => c + c).join('') : h.slice(0, 6);
  return {
    r: parseInt(n.slice(0, 2), 16) || 0,
    g: parseInt(n.slice(2, 4), 16) || 0,
    b: parseInt(n.slice(4, 6), 16) || 0
  };
}

function rgbToHex({ r, g, b }) {
  return `#${[r, g, b].map((x) => clampByte(x).toString(16).padStart(2, '0')).join('')}`;
}

function mixHex(hex, toward, t) {
  const a = hexToRgb(hex);
  const b = hexToRgb(toward);
  return rgbToHex({
    r: a.r + (b.r - a.r) * t,
    g: a.g + (b.g - a.g) * t,
    b: a.b + (b.b - a.b) * t
  });
}

function darkenHex(hex, amount = 0.34) {
  return mixHex(hex, '#000000', amount);
}

function lightenHex(hex, amount = 0.38) {
  return mixHex(hex, '#ffffff', amount);
}

function nextTeardropUid(explicit) {
  if (explicit) return String(explicit).replace(/[^a-zA-Z0-9_-]/g, '');
  teardropUidSeq += 1;
  return `td${teardropUidSeq}`;
}

/** 灰色水滴：圈内图案着色（外框保持灰） */
const GLYPH_COLORS = {
  water_drop: '#38bdf8',
  stationary: '#64748b',
  person: '#2563eb',
  hike: '#1d4ed8',
  walk: '#0284c7',
  run: '#ea580c',
  climb: '#c2410c',
  bicycle: '#0d9488',
  motorcycle: '#7c3aed',
  car: '#0f766e',
  truck: '#155e75',
  bus: '#1d4ed8',
  train: '#4338ca',
  subway: '#4f46e5',
  airplane: '#0369a1',
  helicopter: '#0e7490',
  boat: '#0284c7',
  ambulance: '#dc2626',
  fire_truck: '#b91c1c',
  medical: '#e11d48',
  police: '#1e40af',
  rescue: '#dc2626',
  fire: '#ea580c',
  camp: '#a16207',
  swim: '#0891b2',
  ski: '#2563eb',
  snowboard: '#4f46e5',
  surf: '#0ea5e9',
  fish: '#0369a1',
  hunt: '#166534',
  flag: '#dc2626',
  star: '#ca8a04',
  heart: '#e11d48',
  diamond: '#7c3aed',
  circle: '#2563eb',
  square: '#4b5563',
  triangle: '#d97706'
};

function colorizeGlyph(html, color) {
  return String(html || '')
    .replace(/fill="#fff"/gi, `fill="${color}"`)
    .replace(/stroke="#fff"/gi, `stroke="${color}"`);
}

function isValidGlyphKey(key) {
  return Object.prototype.hasOwnProperty.call(MEMBER_ICON_GLYPHS, key);
}

function isChromeIconKey(key) {
  if (CHROME_EXTRA_KEYS.has(key)) return true;
  if (CHROME_SKIP_KEYS.has(key)) return false;
  return isValidGlyphKey(key);
}

function parseMemberIconRef(raw) {
  const s = String(raw || '').trim();
  if (/^chrome:/i.test(s)) {
    const rest = s.slice(s.indexOf(':') + 1);
    const state = WATER_DROP_STATES.find((st) => rest === `water_drop-${st.color}`);
    if (state) {
      return {
        style: 'chrome',
        key: 'water_drop',
        color: state.color,
        fill: state.fill,
        value: `chrome:water_drop-${state.color}`
      };
    }
    const key = isChromeIconKey(rest) ? rest : 'water_drop';
    const dropState = rest === 'water_drop'
      ? WATER_DROP_STATES.find((st) => st.color === 'lightblue')
      : null;
    return {
      style: 'chrome',
      key,
      color: dropState ? dropState.color : undefined,
      fill: dropState ? dropState.fill : undefined,
      value: `chrome:${key}`
    };
  }
  return {
    style: 'flat',
    key: isValidGlyphKey(s) ? s : s,
    value: s
  };
}

function isValidMemberIconKey(key) {
  if (isValidGlyphKey(key)) return true;
  const parsed = parseMemberIconRef(key);
  return parsed.style === 'chrome' && isChromeIconKey(parsed.key);
}

function resolveSpeedIconKey(speedMs) {
  const n = Number(speedMs);
  if (!Number.isFinite(n) || n < 0) return 'hike';
  for (const band of SPEED_ICON_BANDS) {
    if (n < band.maxMs) return band.key;
  }
  return 'airplane';
}

function getMemberIconPublicUrl(key, { color, style } = {}) {
  const parsed = parseMemberIconRef(key);
  const st = style || parsed.style;
  const k = isChromeIconKey(parsed.key) ? parsed.key : (isValidGlyphKey(parsed.key) ? parsed.key : 'water_drop');
  if (st === 'chrome') {
    const dir = CHROME_PUBLIC_DIR;
    if (k === 'water_drop') {
      const c = color || parsed.color || 'lightblue';
      if (c === 'lightblue') return `${dir}/water_drop.png`;
      return `${dir}/water_drop-${c}.png`;
    }
    return `${dir}/${k}.svg`;
  }
  if (color && color !== 'blue') return `${TEARDROP_PUBLIC_DIR}/${k}-${color}.svg`;
  return `${TEARDROP_PUBLIC_DIR}/${k}.svg`;
}

function toPublicUploadIconUrl(filePath) {
  const raw = String(filePath || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/api/icons/file/')) return raw;
  const m = raw.match(/\/uploads\/icons\/([^/?#]+)$/i);
  if (m) return `/api/icons/file/${encodeURIComponent(m[1])}`;
  return raw;
}

/**
 * 组装水滴 SVG。style=chrome 为指挥页默认灰色外壳；flat 为整颗着色。
 * @param {{ fill: string, iconKey?: string, appBadge?: boolean, uid?: string, pixelWidth?: number, pixelHeight?: number, style?: string }} opts
 */
function resolveCornerBadge(appBadge, cornerBadge) {
  if (cornerBadge === 'app' || cornerBadge === 'lc') return cornerBadge;
  if (appBadge) return 'app';
  return null;
}

function buildCornerBadgeMarkup(cornerBadge) {
  if (cornerBadge === 'app') {
    return `<rect x="18" y="1" width="15" height="11" rx="2.5" fill="#0f766e"/>
       <text x="25.5" y="9" text-anchor="middle" fill="#fff" font-size="7.5" font-weight="700" font-family="system-ui,sans-serif">app</text>`;
  }
  if (cornerBadge === 'lc') {
    return `<rect x="18" y="1" width="14" height="11" rx="2.5" fill="#1d4ed8"/>
       <text x="25" y="9" text-anchor="middle" fill="#fff" font-size="7.5" font-weight="700" font-family="system-ui,sans-serif">lc</text>`;
  }
  return '';
}

function buildTeardropSvgMarkup({
  fill = '#3b82f6',
  iconKey = 'water_drop',
  appBadge = false,
  cornerBadge = null,
  uid: uidOpt,
  pixelWidth,
  pixelHeight,
  style
} = {}) {
  const badge = resolveCornerBadge(appBadge, cornerBadge);
  const parsed = parseMemberIconRef(iconKey);
  const st = style || parsed.style;
  const color = /^#[0-9a-fA-F]{3,8}$/.test(String(fill)) ? fill : '#3b82f6';
  const key = isValidGlyphKey(parsed.key) ? parsed.key : 'water_drop';
  if (st === 'chrome') {
    const dropFill = parsed.fill || color;
    return buildChromeTeardropSvgMarkup({
      color: dropFill,
      key,
      cornerBadge: badge,
      uidOpt,
      pixelWidth,
      pixelHeight
    });
  }
  return buildFlatTeardropSvgMarkup({
    color,
    key,
    cornerBadge: badge,
    pixelWidth,
    pixelHeight
  });
}

function buildFlatTeardropSvgMarkup({ color, key, appBadge, cornerBadge, pixelWidth, pixelHeight }) {
  const badge = resolveCornerBadge(appBadge, cornerBadge);
  const glyph = wrapScaledGlyph(
    MEMBER_ICON_GLYPHS[key] || MEMBER_ICON_GLYPHS.water_drop,
    GLYPH_SCALE,
    GLYPH_CX,
    GLYPH_CY
  );
  const vbW = badge ? 34 : 28;
  const vbH = badge ? 40 : 36;
  const w = pixelWidth || vbW;
  const h = pixelHeight || vbH;
  const pin = `<path d="${TEARDROP_PATH}" fill="${color}" stroke="rgba(0,0,0,.2)" stroke-width="0.5"/>${glyph}`;
  const body = badge
    ? `<g transform="translate(3,4)">${pin}</g>
       ${buildCornerBadgeMarkup(badge)}`
    : pin;
  return `<svg width="${w}" height="${h}" viewBox="0 0 ${vbW} ${vbH}" xmlns="http://www.w3.org/2000/svg">${body}</svg>`;
}

function buildChromeTeardropSvgMarkup({ color, key, appBadge, cornerBadge, uidOpt, pixelWidth, pixelHeight }) {
  const badge = resolveCornerBadge(appBadge, cornerBadge);
  const uid = nextTeardropUid(uidOpt);
  const isDrop = key === 'water_drop';
  const gemFill = /^#[0-9a-fA-F]{3,8}$/.test(String(color)) ? color : '#2ea8ff';
  const gemDark = darkenHex(gemFill, isDrop ? 0.32 : 0.22);
  const gemLite = lightenHex(gemFill, isDrop ? 0.42 : 0.28);
  const gemR = isDrop ? 5.55 : 8.15;
  const glyphColor = '#ffffff';
  const raw = MEMBER_ICON_GLYPHS[key] || MEMBER_ICON_GLYPHS.water_drop;
  const glyph = isDrop
    ? ''
    : wrapScaledGlyph(colorizeGlyph(raw, glyphColor), GLYPH_SCALE_CHROME, 14, 12);
  const vbW = badge ? 34 : 28;
  const vbH = badge ? 40 : 36;
  const w = pixelWidth || vbW;
  const h = pixelHeight || vbH;
  const defs = `
    <defs>
      <linearGradient id="${uid}-shell" x1="22%" y1="0%" x2="82%" y2="100%">
        <stop offset="0%" stop-color="#ffffff"/>
        <stop offset="40%" stop-color="#eef1f4"/>
        <stop offset="100%" stop-color="#9aa3ad"/>
      </linearGradient>
      <radialGradient id="${uid}-shellHi" cx="34%" cy="20%" r="70%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.55"/>
        <stop offset="55%" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="${uid}-gem" cx="36%" cy="30%" r="68%">
        <stop offset="0%" stop-color="${gemLite}"/>
        <stop offset="45%" stop-color="${gemFill}"/>
        <stop offset="100%" stop-color="${gemDark}"/>
      </radialGradient>
      <filter id="${uid}-sh" x="-20%" y="-10%" width="140%" height="140%">
        <feDropShadow dx="0" dy="0.7" stdDeviation="0.45" flood-color="#000" flood-opacity="0.22"/>
      </filter>
      <clipPath id="${uid}-clip">
        <circle cx="${GEM_CX}" cy="${GEM_CY}" r="${gemR}"/>
      </clipPath>
    </defs>`;
  const pin = `
    <path d="${CHROME_TEARDROP_PATH}" fill="url(#${uid}-shell)" stroke="#c5cbd2" stroke-width="0.28" filter="url(#${uid}-sh)"/>
    <path d="${CHROME_TEARDROP_PATH}" fill="url(#${uid}-shellHi)"/>
    <circle cx="${GEM_CX}" cy="${GEM_CY}" r="${gemR}" fill="url(#${uid}-gem)"/>
    <circle cx="${GEM_CX}" cy="${GEM_CY}" r="${gemR}" fill="none" stroke="rgba(255,255,255,.4)" stroke-width="0.35"/>
    ${isDrop
    ? `<ellipse cx="${GEM_CX - 1.7}" cy="${GEM_CY - 2.05}" rx="2.05" ry="1.05" fill="#fff" opacity="0.4"/>`
    : `<g clip-path="url(#${uid}-clip)">${glyph}</g>`}`;
  const body = badge
    ? `<g transform="translate(3,4)">${pin}</g>
       ${buildCornerBadgeMarkup(badge)}`
    : pin;
  return `<svg width="${w}" height="${h}" viewBox="0 0 ${vbW} ${vbH}" xmlns="http://www.w3.org/2000/svg">${defs}${body}</svg>`;
}

/**
 * 解析队员地图图标 key
 * @param {object} member
 * @param {{ speedAuto?: boolean, presence?: string, state?: string }} opts
 */
function resolveMemberIconKey(member, { speedAuto = true } = {}) {
  const manual = String(member?.icon || '').trim();
  const speed = member?.last_speed;
  if (speedAuto) {
    if (speed != null && speed !== '' && Number.isFinite(Number(speed))) {
      return resolveSpeedIconKey(speed);
    }
    if (manual && isValidMemberIconKey(manual) && manual !== 'water_drop') return manual;
    return 'water_drop';
  }
  if (manual && isValidMemberIconKey(manual)) return manual;
  return 'water_drop';
}

/**
 * 指挥台灰色水滴：在线/暂时离线/选中/高亮/离线对应五枚状态图标。
 */
function chromeStatusForMarkerState(state) {
  const s = String(state || '');
  if (s === 'active') {
    return { color: 'red', fill: '#e23b3b', iconKey: 'chrome:water_drop-red', useFile: true };
  }
  if (s === 'highlighted') {
    return { color: 'darkblue', fill: '#2b5fd0', iconKey: 'chrome:water_drop-darkblue', useFile: true };
  }
  if (s === 'online') {
    return { color: 'lightblue', fill: '#2ea8ff', iconKey: 'chrome:water_drop', useFile: true };
  }
  if (s === 'temp_offline') {
    return { color: 'orange', fill: '#f59e0b', iconKey: 'chrome:water_drop-orange', useFile: true };
  }
  return { color: 'gray', fill: '#8a93a0', iconKey: 'chrome:water_drop-gray', useFile: true };
}

function toChromeIconKey(raw) {
  const parsed = parseMemberIconRef(raw);
  if (parsed.style === 'chrome') return parsed.value || `chrome:${parsed.key}`;
  if (!parsed.key || parsed.key === 'water_drop') return 'chrome:water_drop';
  return `chrome:${parsed.key}`;
}

function listIcons({ style } = {}) {
  const styles = style
    ? ICON_STYLES.filter((s) => s.id === style)
    : ICON_STYLES;
  const rows = [];
  for (const st of styles) {
    for (const item of MEMBER_ICON_CATALOG) {
      if (st.id === 'chrome' && item.key === 'water_drop') {
        for (const state of WATER_DROP_STATES) {
          const value = state.color === 'lightblue'
            ? 'chrome:water_drop'
            : `chrome:water_drop-${state.color}`;
          rows.push({
            value,
            key: 'water_drop',
            style: 'chrome',
            styleLabel: st.label,
            color: state.color,
            label: state.label,
            description: state.description,
            url: getMemberIconPublicUrl('water_drop', { style: 'chrome', color: state.color })
          });
        }
        continue;
      }
      if (st.id === 'chrome' && CHROME_SKIP_KEYS.has(item.key)) continue;
      const value = st.id === 'chrome' ? `chrome:${item.key}` : item.key;
      rows.push({
        value,
        key: item.key,
        style: st.id,
        styleLabel: st.label,
        label: item.label,
        description: item.description,
        url: getMemberIconPublicUrl(item.key, { style: st.id })
      });
    }
    if (st.id === 'chrome') {
      for (const item of CHROME_EXTRA_CATALOG) {
        rows.push({
          value: `chrome:${item.key}`,
          key: item.key,
          style: 'chrome',
          styleLabel: st.label,
          label: item.label,
          description: item.description,
          url: getMemberIconPublicUrl(item.key, { style: 'chrome' })
        });
      }
    }
  }
  return rows;
}

function listIconStyles() {
  return ICON_STYLES.map((s) => ({ ...s }));
}

function listSpeedBands() {
  return SPEED_ICON_BANDS.map((b) => ({
    key: b.key,
    label: b.label,
    maxMs: b.maxMs === Infinity ? null : b.maxMs,
    maxKmh: b.maxKmh
  }));
}

module.exports = {
  TEARDROP_PATH,
  CHROME_TEARDROP_PATH,
  GEM_CX,
  GEM_CY,
  GEM_R,
  ICON_STYLES,
  WATER_DROP_STATES,
  CHROME_EXTRA_CATALOG,
  MEMBER_ICON_GLYPHS,
  MEMBER_ICON_CATALOG,
  SPEED_ICON_BANDS,
  TEARDROP_PUBLIC_DIR,
  CHROME_PUBLIC_DIR,
  isValidMemberIconKey,
  parseMemberIconRef,
  resolveSpeedIconKey,
  getMemberIconPublicUrl,
  toPublicUploadIconUrl,
  wrapScaledGlyph,
  GLYPH_SCALE,
  GLYPH_SCALE_CHROME,
  buildTeardropSvgMarkup,
  resolveMemberIconKey,
  chromeStatusForMarkerState,
  toChromeIconKey,
  listIcons,
  listIconStyles,
  listSpeedBands,
  ICON_GLYPHS: MEMBER_ICON_GLYPHS,
  ICON_CATALOG: MEMBER_ICON_CATALOG,
  isValidIconKey: isValidMemberIconKey,
  getIconPublicUrl: getMemberIconPublicUrl,
  buildTeardropSvg: buildTeardropSvgMarkup,
  resolveIconKeyForMember: resolveMemberIconKey
};
